export default __webpack_public_path__ + "static/media/sponsor-active.61e70cab.svg";